import moment from 'moment';
export const validateEmail = (email) => {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    let valid = re.test(String(email).toLowerCase());
    return valid;
}
export const validateContactNo = (phoneNo) => {
    var reg = /^[89]\d{7}$/;
    let valid = reg.test(String(phoneNo).toLowerCase());
    return valid;
}

export const validateNric = (nric) => {
    if (nric) {
        var reg = /^[stfg]\d{7}[a-z]$/;
        var valid = reg.test(String(nric).toLowerCase())
        return valid;
    }
}
export const validatePostalCode = (postal_code) => {
    var reg = /^\d{6}$/;
    let valid = reg.test(String(postal_code).toLowerCase())
    return valid
}
export const validateDOBFormat = (dob) => {
    // var reg = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
    var reg = /(?:\D|^)(?<year>\d{4})(?<sep>[^\w\s])(?<month>1[0-2]|0[1-9])\k<sep>(?<day>0[1-9]|[12][0-9]|(?:11\k<sep>|[^1][4-9]\k<sep>)30|(?:1[02]\k<sep>|[^1][13578]\k<sep>)3[01])(?=\D|$)/gm
    let valid = reg.test(String(dob).toLowerCase())
    return valid;
}